import { motion, AnimatePresence } from "framer-motion";
import { useCall } from "@/context/CallContext";
import { dollars } from "@/lib/giftIcons";
import { Lock, X, Video } from "lucide-react";

export default function PrivateConfirmModal({ open, onClose, user }) {
  const { startPrivateCall } = useCall();
  if (!open || !user) return null;

  const confirm = () => {
    onClose();
    startPrivateCall(user);
  };

  return (
    <AnimatePresence>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
        className="fixed inset-0 z-[9998] bg-ink/90 backdrop-blur-md flex items-center justify-center px-4"
        onClick={onClose}>
        <motion.div data-testid="private-confirm-modal"
          initial={{ opacity: 0, scale: 0.94, y: 16 }} animate={{ opacity: 1, scale: 1, y: 0 }}
          className="relative w-full max-w-md rounded-3xl border border-wine/40 bg-surface p-8"
          onClick={(e) => e.stopPropagation()}>
          <button data-testid="private-confirm-close" onClick={onClose}
            className="absolute top-5 right-5 p-2 text-text-muted hover:text-text-main transition-colors"><X size={16} /></button>
          <p className="flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-gold"><Lock size={13} /> Private session</p>
          <h2 className="font-display text-4xl font-light mt-3">One-on-one with {user.display_name}</h2>
          <p data-testid="private-confirm-rate" className="font-display text-5xl font-light text-gold mt-6">
            {dollars(user.private_rate)}<span className="text-lg text-text-muted"> / minute</span>
          </p>
          <ul className="text-sm text-text-muted mt-6 space-y-2">
            <li>· Billed from your wallet minute by minute</li>
            <li>· First minute is charged when the call connects</li>
            <li>· A live timer shows exactly what you're spending</li>
            <li>· Session ends automatically if your balance runs out</li>
          </ul>
          <button data-testid="private-confirm-start" onClick={confirm}
            className="mt-8 w-full py-3.5 rounded-full bg-wine hover:bg-wine-hover transition-colors text-sm uppercase tracking-[0.2em] flex items-center justify-center gap-2">
            <Video size={15} /> Start private · {dollars(user.private_rate)}/min
          </button>
          <button data-testid="private-confirm-cancel" onClick={onClose}
            className="mt-3 w-full py-3 rounded-full border border-white/10 text-text-muted hover:border-white/30 transition-colors text-xs uppercase tracking-[0.2em]">
            Not now
          </button>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
